import { registerLocaleData } from '@angular/common';
import { bootstrapApplication } from '@angular/platform-browser';
import localeDe from '@angular/common/locales/de';
import 'chartjs-adapter-date-fns';

import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';

registerLocaleData(localeDe);

bootstrapApplication(AppComponent, appConfig).catch(err => {
  console.error('Application bootstrap failed:', {
    error: err.message,
    stack: err.stack,
  });
});
